import { ISelfSubscribe } from '@Common/Core/MulticastDelegate';

export interface Control {
    getControl(): JQuery;

    setState(enabled: boolean): void;
}

export interface IAdjustable {
    adjust(width?: number | string, height?: number | string): void;
}

export interface IControl extends Control, IAdjustable {
    enabled(value?: boolean): boolean;

    visible(value?: boolean): boolean;

    readonly(readonly?: boolean): boolean;

    destroy?(): void;
}

export type ValidationCallback = (isValid: boolean, errors?: string[]) => void;

export interface IValidationControl {
    onValidate: ISelfSubscribe<ValidationCallback>;

    validate(): boolean; //TODO: make validate async
    readonly isValid: boolean;
}

export interface IErrorControl {
    removeError(): void;

    setError(message: string): void;
}

export interface IValueChange<TChangedValue = any> {
    onChange: ISelfSubscribe<TChangedValue extends void ? IHandler : ICallback<TChangedValue>>;
}

export interface IValueControl<T, TChangedValue = any> extends IValueChange<TChangedValue> {
    getValue(): T;

    setValue(value: T): void;
}

export function isValidationControl<T>(ctrl: T): ctrl is T & IValidationControl {
    return 'onValidate' in ctrl && 'validate' in ctrl;
}

export function isControl(obj: any): obj is IControl {
    return obj && _.isFunction(obj.getControl);
}

export function isAdjustable(obj: any): obj is IAdjustable {
    return obj && _.isFunction(obj.adjust);
}

export interface IMargins {
    top?: boolean;
    left?: boolean;
    right?: boolean;
    bottom?: boolean;
}
